import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const http_options = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json'
	})
};

class Branch {
	branch_name:string;
	address:string;
	phone_no:string;
}

@Injectable()
export class BranchMasterService {

	private url = environment.url;
	private branchUrl =  this.url + '/branch/all';
	public selected_branch:string=null;

	constructor(private http: HttpClient) { }

	addNewBranch(form): Observable<string>{
		return this.http.post<string>(this.url + '/branch/submit', form, http_options);
	}

	getBranches(): Observable<Branch[]> {
		return this.http.get<Branch[]>(this.branchUrl);
	}
	getBranchMasterFormWith(name:string): Observable<Branch[]> 
	{
		console.log (this.http.get<Branch[]>(this.url + '/branch/get/' + name));
		return this.http.get<Branch[]>(this.url + '/branch/get/' + name);
	}
	// getSelectedBranch(branch:string){
	// 	this.selected_branch = branch;
	// 	console.log(this.selected_branch);
	// };
}




// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/_services/_masters/branch-master.service.ts